module.exports = __webpack_public_path__ + "media/chronic gastritis.578725af.wav";